import Image from "next/image";
import Link from "next/link";
import React, { Component } from "react";
import { BaseButtonProps, ButtonType } from "@/types/ui-kit/buttons";
import classNames from "classnames";
import { Loader } from "@/components/ui-kit/Loader";

export const BaseButton: React.FC<BaseButtonProps> = ({
  title,
  iconPath,
  beforeIconPath,
  onClick,
  href = "",
  type,
  fullWidth,
  small,
  hasUpChevron,
  component: Component = Link,
  isLoading = false,
}) => {
  return (
    <Component
      onClick={onClick}
      href={href}
      className={classNames(
        "relative flex h-full cursor-pointer items-center justify-center rounded-sm py-3 font-sans text-sm transition-colors ease-in-out",
        {
          "flex items-center justify-center rounded-sm bg-dark text-white hover:bg-orange active:bg-orange dark:bg-white dark:text-dark dark:hover:bg-middle-light-turquoise":
            type === ButtonType.Primary,
          "flex min-w-[256px] items-center justify-center !rounded-full bg-dark text-white hover:bg-orange active:bg-orange dark:bg-white dark:text-dark dark:hover:bg-middle-light-turquoise hpLg:min-w-[200px]":
            type === ButtonType.PrimaryRounded,
          "flex items-center justify-center rounded-sm bg-dark !py-2 text-white hover:bg-orange active:bg-orange dark:bg-white dark:text-dark dark:hover:bg-middle-light-turquoise":
            type === ButtonType.PrimaryMd,
          "ml-3 rounded-full border px-5 py-2": type === ButtonType.Secondary,
          "w-full": fullWidth === true,
          "py-[12px] text-md lg:py-[10px] lg:text-2xs": small === true,
          "bg-transparent text-black hover:bg-dark/5 active:bg-dark/10 dark:text-white dark:hover:bg-white-25":
            type === ButtonType.Transparent,
          "min-w-[256px] !rounded-full bg-transparent text-black hover:bg-dark/5 active:bg-dark/10 dark:text-white dark:hover:bg-white-25 hpLg:min-w-[200px]":
            type === ButtonType.TransparentRounded,
          "min-w-[256px] !rounded-full border border-gray-300 bg-transparent text-black hover:bg-dark/5 active:bg-dark/10 dark:text-white dark:hover:bg-white-25 hpLg:min-w-[200px]":
            type === ButtonType.TransparentStroked,
        }
      )}
      disabled={isLoading}
      data-gtm_button_cta={title}
    >
      {isLoading ? (
        <>
          <Loader className="h-4 w-4" />
          &nbsp;
        </>
      ) : (
        <>
          {hasUpChevron && (
            <Image
              src="/assets/images/icons/chevron-up.svg"
              alt="Chevron Up"
              width={20}
              height={20}
              className="mr-[8px] dark:invert"
            />
          )}
          {beforeIconPath && (
            <Image src={beforeIconPath} alt="Unlock" width={14} height={14} className="mb-0.5 mr-2 dark:invert" />
          )}
          {title}
          {iconPath && (
            <Image
              src={iconPath}
              alt="Chevron right"
              width={7}
              height={7}
              className={`absolute dark:invert ${type === ButtonType.PrimaryRounded ? "right-3.5" : "right-6"}`}
            />
          )}
        </>
      )}
    </Component>
  );
};
